import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage';
import 'firebase/performance';
import 'firebase/analytics';
import { isDev } from './GlobalParams';
import { reject } from 'lodash';
import dayjs, { Dayjs } from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { dataService } from './dataService';

dayjs.extend(relativeTime);

let firebaseObj = new Promise((resolve, reject) => {
    if (isDev) {
        var firebaseConfig = {
            apiKey: 'AIzaSyBzde4WOg-HsItjHBd7g4yX8JDsS4LI9HY',
            authDomain: 'sparedoxdev.firebaseapp.com',
            databaseURL: 'https://sparedoxdev.firebaseio.com',
            projectId: 'sparedoxdev',
            storageBucket: 'sparedoxdev.appspot.com',
            messagingSenderId: '863519551855',
            appId: '1:863519551855:web:22b8acec45058182bb789a',
            measurementId: 'G-3RHN7CS20Z'
        };
        firebase.initializeApp(firebaseConfig);
        resolve({
            //auth: firebase.auth(),
            //firestore: firebase.firestore(),
            //storage: firebase.storage(),
            perf: firebase.performance(),
            analytics: firebase.analytics()
        });
    } else {
        fetch('/__/firebase/init.json').then(async (response) => {
            firebase.initializeApp(await response.json());
            resolve({
                // auth: firebase.auth(),
                //firestore: firebase.firestore(),
                //storage: firebase.storage(),
                perf: firebase.performance(),
                analytics: firebase.analytics()
            });
            // (await firebase.firestore().collection().where().orderBy()
        });
    }
});

const provider = new firebase.auth.GoogleAuthProvider();

const Timestamp = firebase.firestore.Timestamp;

const signInWithGoogle = async () => {
    let auth = firebase.auth();
    return await auth.signInWithPopup(provider);
};

const generateUserDocument = async (user, additionalData) => {
    if (!user) return;
    const userRef = await dataService.firestore.doc(`users/${user.uid}`);
    const snapshot = await userRef.get();
    if (!snapshot.exists) {
        const { email, displayName, photoURL, uid } = user;
        try {
            await userRef.set({
                key: uid,
                displayName,
                email,
                photoURL,
                ...additionalData
            });
        } catch (error) {
            console.error('Error creating user document', error);
        }
    }
    return getUserDocument(user.uid);
};

const getUserDocument = async (uid) => {
    if (!uid) return null;
    try {
        const userRef = dataService.firestore.doc(`users/${uid}`);
        const userDocument = await userRef.get();

        //Create Record if not
        if (userDocument == null) {
            userRef.set();
        }

        return {
            uid,
            ...userDocument.data()
        };
    } catch (error) {
        console.error('Error fetching user', error);
    }
};

const getTime = () => {
    return Timestamp.fromDate(new Date());
};

const covertToDaysJS = (val: Timestamp) => {
    if (val) {
        if (val.toDate == undefined && val.seconds) {
            val = new Timestamp(val.seconds, val.nanoseconds);
            return dayjs().to(val.toDate());
        }
        if (val.getMonth) return dayjs().to(val);
        else return dayjs().to(new Date(val));
    } else {
        return null;
    }
};

export {
    firebaseObj,
    signInWithGoogle,
    generateUserDocument,
    getTime,
    covertToDaysJS
};



// WEBPACK FOOTER //
// ./demo/src/firebase.js